// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__DD29P","error":"TextInput_error__YWq_N"};